import { useIntl } from 'react-intl';

import type { CountryCodeEnumType } from '@/types/regionTypes';

import type { SelectFieldProps } from '@/components/SelectField';
import { SelectField } from '@/components/SelectField';
import { formMessages } from '@/messages/forms';

import { getTitleOptions } from './utils';

interface Props extends Omit<SelectFieldProps, 'name'> {
  countryCode: string;
  name?: string;
}

export const TitleField = ({ countryCode, name, ...props }: Props) => {
  const { formatMessage } = useIntl();
  const isJapan = countryCode === 'JP';
  const placeholder = isJapan
    ? formatMessage(formMessages.gender)
    : formatMessage(formMessages.title);
  const ariaLabel = isJapan
    ? formatMessage(formMessages.gender)
    : formatMessage(formMessages.title);

  return (
    <SelectField
      aria-label={ariaLabel}
      backspaceRemovesValue={false}
      colorVariant={props.colorVariant}
      data-test-id='selectTitle'
      flexProps={{ alignItems: 'flex-start', flexDirection: 'column' }}
      isClearable={false}
      isDisabled={props.isDisabled}
      name={name ?? 'title'}
      options={getTitleOptions(
        formatMessage,
        countryCode as CountryCodeEnumType,
      )}
      placeholder={placeholder}
      required={true}
    />
  );
};
